"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../utils/constants");
var muiShare16 = {
    paths: [
        {
            path: 'M10.7959326,3.59708324 C11.1308909,3.85001151 11.5479296,4 12,4 C13.1045695,4 14,3.1045695 14,2 C14,0.8954305 13.1045695,0 12,0 C10.8954305,0 10,0.8954305 10,2 C10,2.10576536 10.0082098,2.20961322 10.0240269,2.31094107 L3.20406742,6.40291676 C2.86910911,6.14998849 2.4520704,6 2,6 C0.8954305,6 0,6.8954305 0,8 C0,9.1045695 0.8954305,10 2,10 C2.4520704,10 2.86910911,9.85001151 3.20406742,9.59708324 L10.0240269,13.6890589 C10.0082098,13.7903868 10,13.8942346 10,14 C10,15.1045695 10.8954305,16 12,16 C13.1045695,16 14,15.1045695 14,14 C14,12.8954305 13.1045695,12 12,12 C11.5479296,12 11.1308909,12.1499885 10.7959326,12.4029168 L3.9759731,8.31094107 C3.9917902,8.20961322 4,8.10576536 4,8 C4,7.89423464 3.9917902,7.79038678 3.9759731,7.68905893 L10.7959326,3.59708324 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Share',
    width: 14,
    height: 16,
};
var muiShare24 = {
    paths: [
        {
            path: 'M17,0 C18.6568542,-3.04359188e-16 20,1.34314575 20,3 C20,4.65685425 18.6568542,6 17,6 C16.2292669,6 15.5264175,5.70935521 14.9950756,5.2316893 L5.9362513,10.3818746 C5.97803271,10.5813502 6,10.7881097 6,11 C6,11.1564115 5.98803007,11.3100272 5.96495627,11.4599812 L15.0526343,16.7178717 C15.5766883,16.2702629 16.2567825,16 17,16 C18.6568542,16 20,17.3431458 20,19 C20,20.6568542 18.6568542,22 17,22 C15.3431458,22 14,20.6568542 14,19 C14,18.8114956 14.0173859,18.6270519 14.0506417,18.448185 L5.01611725,13.2215765 C4.48347205,13.7052498 3.77615732,14 3,14 C1.34314575,14 2.02906125e-16,12.6568542 0,11 C-2.02906125e-16,9.34314575 1.34314575,8 3,8 C3.71765458,8 4.37645346,8.25199125 4.89274134,8.67231846 L14.0375357,3.47589167 C14.0128324,3.32089916 14,3.16194816 14,3 C14,1.34314575 15.3431458,3.04359188e-16 17,0 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Share',
    width: 20,
    height: 22,
};
var muiShare = {
    base: muiShare16,
    smIcon: muiShare16,
    lgIcon: muiShare24,
};
exports.muiShare = muiShare;
//# sourceMappingURL=share.js.map